import { ErrorBoundary } from 'react-error-boundary'
import { useEffect, useState } from 'react'
import { HRMApp } from '../custom-layout/App'

const localStorageKey =
  process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY || 'i24h-token-m365-hrm'

function App() {
  const [forgeReady, setForgeReady] = useState<boolean>(false)

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Log all incoming messages for debugging
      // console.log("Received message:", event.data);

      // Handle specific ict24h events
      if (event.data.type?.substring(0, 7) === 'ict24h-') {
        // console.log("Received message: .ict24h", event.data);
        if (event.data.type === 'ict24h-auth-encrypted' && event.data.payload) {
          localStorage.setItem(localStorageKey, event.data.payload)
          setForgeReady(true)
        }
      }
    }

    window.addEventListener('message', handleMessage)

    window.parent.postMessage({ type: 'ict24h-auth-request' }, '*')
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  return (
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
      {forgeReady && <HRMApp />}
    </ErrorBoundary>
  )
}

export default App
